<template>
    <div class="simple-form">
        <el-form :model="devcManual" :rules="rules" ref="ruleForm" class="demo-ruleForm">
            <div class="form-group" v-if="manualId != null && manualId > 0">
                <div class="form-label">
                    <label class="required">名称</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="fileName">
                        <el-input class="width-1-5x" type="text" v-model="devcManual.fileName"></el-input>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group" v-if="manualId != null && manualId > 0">
                <div class="form-label">
                    <label class="required">使用范围</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="innerOnly">
                        <el-radio-group v-model="devcManual.innerOnly">
                            <el-radio :label="false">通用</el-radio>
                            <el-radio :label="true">内部使用</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
            </div>

            <div class="form-group top" v-if="manualId == null">
                <div class="form-label">
                    <label>资料手册</label>
                </div>
                <div class="form-value">
                    <swb-file-upload :fileFor="'assets'" fileGroup="assets" :onBeforeUpload="onBeforeFileUpload" :onProgress="onProgress" :onDone="onFileUploadDone" :multipleFile="true"></swb-file-upload>
                    <ul class="file-area input clearfix" v-if="devcFiles != null && devcFiles.length > 0">
                        <li class="file-content clearfix" v-for="(devcFile, index) in devcFiles">
                            <swb-file-item :trackKey="index" :fileName="devcFile.fileName" :fileUuid="devcFile.fileUuid" :downloadable="true" :fileDownloadUrl="devcFile.fileBrowseUrl" :deletable="true" :onDelete="(event)=>{removeFileUpload(event, devcFile)}"></swb-file-item>
                            <div class="file-right">
                                <div class="row clearfix">
                                    <div class="label required">名称</div>
                                    <div class="value">
                                        <el-input placeholder="请输入手册名称" type="text" style="width: 170px" v-model="devcFile.fileName"></el-input>
                                    </div>
                                </div>
                                <div class="row clearfix">
                                    <div class="label required">使用范围</div>
                                    <div class="value">
                                        <el-radio-group v-model="devcFile.innerOnly">
                                            <el-radio :label="false">通用</el-radio>
                                            <el-radio :label="true">内部使用</el-radio>
                                        </el-radio-group>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </el-form>
    </div>

</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import appConf from '../../app.conf';
    import devcDefApi from '../../api/devcDef'

    export default {
        name: 'swb-mercht-devc-manual-save',
        desc: '资料手册保存',
        props: {
            manualId: {
                type: Number,
                default: null
            }
        },
        data: function () {
            let checkFileName = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('名称不能为空'));
                } else {
                    callback();
                }
            };
            let checkInnerOnly = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('使用范围不能为空'));
                } else {
                    callback();
                }
            };
            return {
                rules: {
                    fileName: [{validator: checkFileName, trigger: 'blur'}],
                    innerOnly: [{validator: checkInnerOnly, trigger: 'blur'}]
                },
                //
                devcManual: {},
                devcFiles: []
            }
        },
        created: function () {
            //
            if(!Utils.isNoB(this.manualId)) {
                this.getDevcDefDetail();
            }
        },
        methods: {
            // 查看资产定义详情
            getDevcDefDetail: function () {
                let self = this;
                let postData = {};
                postData.id = self.manualId;
                //
                let msgBoxDlg = MsgBox.loading();
                devcDefApi.getMerchtDevcManualDetail(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        let devcManual = result.data;
                        self.devcManual = Utils.merge({}, devcManual);
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            // 上传资料手册
            onBeforeFileUpload: function (fileItems, uploader) {
                if(fileItems.length === 0) {
                    MsgBox.warning('喂，你还没选择要上传的文件吧');
                    return false;
                } else {
                    let fileName = fileItems[0].name;
                    if(!Utils.isNoB(fileName)) {
                        if(!appConf.isViewableDocType(fileName)) {
                            MsgBox.warning('允许的文件扩展名为：' + appConf.viewableDocExtNames.join('、'));
                            return false;
                        }
                    }
                    let size = fileItems[0].size;
                    let sizeKB = size / 1024;
                    if(sizeKB > 20 * 1024) {
                        let sizeMB = (sizeKB / 1024).toFixed(2);
                        MsgBox.warning('最大支持20MB,当前' + sizeMB + 'MB');
                        return false;
                    }
                }
            },
            onFileUploadDone: function (result) {
                let self = this;
                if(result.type === 'info') {
                    let files = result.data.files || [];
                    if(files.length > 0) {
                        let devcFiles = self.devcFiles || [];
                        if((files.length + devcFiles.length) > 5) {
                            Toast.show('每次最多可上传5个手册', 3000, 'warning');
                            return;
                        }
                        let fileNames = devcFiles.pluck("fileName") || [];
                        for(let i = 0; i < files.length; i++) {
                            let file = files[i];
                            if(!fileNames.contains(file.fileName)) {
                                let devcFile = {
                                    fileUuid: file.fileUuid,
                                    fileName: file.fileName,
                                    fileBrowseUrl: file.fileBrowseUrl,
                                    innerOnly: false
                                };
                                devcFiles.push(devcFile);
                            }
                        }
                        self.devcFiles = Utils.merge([], devcFiles);
                    }
                } else {
                    MsgBox.warning(result.message);
                }
            },
            removeFileUpload: function (event, file) {
                let devcFiles = this.devcFiles || [];
                for(let i = 0; i < devcFiles.length; i++) {
                    let devcFile = devcFiles[i];
                    if(devcFile.fileUuid == file.fileUuid) {
                        devcFiles.splice(i, 1);
                    }
                }
                this.devcFiles = Utils.merge([], devcFiles);
            },
            // 返回数据
            getDlgResult: function () {
                let self = this;
                let result = {};
                let returnFlag = true;
                this.$refs['ruleForm'].validate(function (valid) {
                    if(valid) {
                        //
                        let resultData = {};
                        if(!Utils.isNoB(self.manualId)) {
                            resultData.id = self.manualId;
                            resultData.fileName = self.devcManual.fileName;
                            resultData.innerOnly = self.devcManual.innerOnly;
                            result.type = 'info';
                            result.data = resultData;
                        } else {
                            let devcFiles = self.devcFiles || [];
                            if(devcFiles.length <= 0) {
                                result.type = 'warn';
                                result.message = '请上传资料手册信息！';
                            } else {
                                for(let i = 0; i < devcFiles.length; i++) {
                                    let devcFile = devcFiles[i];
                                    if(Utils.isNoB(devcFile.fileName)) {
                                        returnFlag = false;
                                        Toast.show("手册名称不能为空！");
                                        return;
                                    }
                                    if(Utils.isNoB(devcFile.innerOnly)) {
                                        returnFlag = false;
                                        Toast.show("请选择使用范围！");
                                        return;
                                    }
                                }
                                //
                                resultData.merchtDevcManuals = devcFiles;
                                result.type = 'info';
                                result.data = resultData;
                            }
                        }
                    } else {
                        result.type = 'warn';
                        result.message = '校验失败';
                    }
                });
                if(Utils.isTrue(returnFlag)) {
                    return result;
                }
            }
        }
    }
</script>

<style>
    .file-area .file-content {
        width: auto;
    }

    .file-area .file-item {
        float: left !important;
    }

    .file-area .file-right {
        float: left;
    }

    .file-area .file-right .row {
        display: flex;
        align-items: center;
        padding: 5px 0;
    }

    .file-area .file-right .row .label {
        float: left;
        width: 68px;
        text-align: right;
        margin-right: 10px;
        position: relative;
    }

    .file-area .file-right .row .value {
        float: left;
    }

    .file-area.input .file-content .el-input {
        margin-bottom: 0px;
    }

    .file-area .label.required:before {
        content: '*';
        color: #FF0000;
        margin-right: 4px;
        vertical-align: middle;
    }
</style>



// WEBPACK FOOTER //
// src/compo/devcDef/MerchtDevcManualSave.vue